/**
 * MXlab — Événements panier maison (sans dépendance).
 *
 * Porté de custom-lab-shopify-app/extensions/configure-button/assets/cart-events.js
 * (technique décrite ici : https://bilalakbar.dev/how-to-listen-to-shopify-cart-events/).
 *
 * On enveloppe `fetch` et `XMLHttpRequest` : tout appel réussi vers une route
 * /cart/* émet un CustomEvent sur `window`. Aucun couplage au thème, aucune
 * réécriture du rendu — juste un signal. Le seul consommateur ici est le pont
 * Custom Lab (mx-customlab.js), qui écoute `mx:cart:add` pour savoir qu'une
 * configuration vient d'être ajoutée au panier.
 *
 * Évènements émis (detail = objet panier/réponse quand disponible) :
 *   mx:cart:mutate  (toute route /cart/*)
 *   mx:cart:add | mx:cart:update | mx:cart:change | mx:cart:clear
 *
 * ÉCHEC SILENCIEUX : si `window`/`Shopify` absents, on ne fait rien. Idempotent :
 * on n'enveloppe fetch/XHR qu'une fois (drapeau global), même si l'asset est
 * inclus par plusieurs blocs.
 */
(function () {
  if (typeof window === 'undefined' || !window.Shopify) return;
  if (window.__mxCartEvents) return; // déjà installé
  window.__mxCartEvents = true;

  var EVENTS = {
    add: 'mx:cart:add',
    update: 'mx:cart:update',
    change: 'mx:cart:change',
    clear: 'mx:cart:clear',
    mutate: 'mx:cart:mutate',
  };

  // On matche sur le DERNIER segment d'URL (couvre les routes localisées
  // /fr/cart/add.js comme /cart/add.js).
  var CART_ENDPOINTS = ['add', 'update', 'change', 'clear', 'add.js', 'update.js', 'change.js', 'clear.js'];

  function isCartURL(url) {
    if (!url) return false;
    var path = String(url).split('?')[0].split('/').pop();
    return CART_ENDPOINTS.indexOf(path) !== -1;
  }

  function typeOf(url) {
    url = String(url);
    if (url.indexOf('cart/add') !== -1) return 'add';
    if (url.indexOf('cart/update') !== -1) return 'update';
    if (url.indexOf('cart/change') !== -1) return 'change';
    if (url.indexOf('cart/clear') !== -1) return 'clear';
    return null;
  }

  function dispatch(url, detail) {
    if (typeof detail === 'string') {
      try {
        detail = JSON.parse(detail);
      } catch (e) {
        /* réponse non-JSON : on émet quand même, detail = brut */
      }
    }
    try {
      window.dispatchEvent(new CustomEvent(EVENTS.mutate, { detail: detail }));
      var t = typeOf(url);
      if (t && EVENTS[t]) window.dispatchEvent(new CustomEvent(EVENTS[t], { detail: detail }));
    } catch (e) {
      /* échec silencieux */
    }
  }

  // fetch (chemin utilisé par le thème natif ET par mx-options).
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      // Un Request a son URL dans .url ; une string est l'URL directe.
      if (url && typeof url === 'object' && 'url' in url) url = url.url;
      var response = originalFetch.apply(this, arguments);
      if (isCartURL(url)) {
        response.then(function (res) {
          res
            .clone()
            .json()
            .then(function (data) {
              dispatch(res.url || url, data);
            })
            .catch(function () {});
        });
      }
      return response;
    };
  }

  // XMLHttpRequest (certains thèmes/apps l'utilisent encore).
  if (window.XMLHttpRequest) {
    var originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      var url = arguments[1];
      if (isCartURL(url)) {
        this.addEventListener('load', function () {
          dispatch(url, this.response);
        });
      }
      return originalOpen.apply(this, arguments);
    };
  }
})();
